<script>
import NewsletterForm from '@phoenix/mixins/components/form/NewsletterForm';

export default {
  mixins: [NewsletterForm],

  computed: {
    termsLink() {
      return this.privacyLink
        ? this.$t('Form.newsletter.agree', {
            privacyLink: this.privacyLink,
          })
        : '';
    },

    isChinaDatacenter() {
      return window.Phoenix.config.DATACENTER === 'china';
    },
  },
};
</script>

<template>
  <div>
    <phoenix-form
      v-model="fields"
      :action="action"
      :captcha-enabled="enableCaptcha"
      data-cy="newsletter-form"
      form-type="newsletter"
      korean-form-type="newsletter"
      :on-success-callback="addTrackingInformation"
      :prefill-enabled="true"
      :redirect-url="redirectUrl"
      :should-reset-form-on-submit="true"
      :terms-link="termsLink"
      :privacy-link="privacyLink"
    >
      <div class="flex-grid flex-grid--x--md flex-grid--y--md">
        <div class="w-full md:w-1/2">
          <form-group :attrs="fields.country">
            <select-field v-model="fields.country.value" />
          </form-group>
        </div>
        <div class="w-full md:w-1/2">
          <form-group v-if="fieldIsPresent('title')" :attrs="fields.title">
            <select-field v-model="fields.title.value" />
          </form-group>
          <form-group v-if="fieldIsPresent('gender')" :attrs="fields.gender">
            <select-field v-model="fields.gender.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('firstName2') && isArabicLanguage" class="w-full md:w-1/2">
          <form-group :attrs="fields.firstName2">
            <text-field v-model="fields.firstName2.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('lastName2') && isArabicLanguage" class="w-full md:w-1/2">
          <form-group :attrs="fields.lastName2">
            <text-field v-model="fields.lastName2.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('firstName1')" class="w-full md:w-1/2">
          <form-group :attrs="fields.firstName1">
            <text-field v-model="fields.firstName1.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('lastName1')" class="w-full md:w-1/2">
          <form-group :attrs="fields.lastName1">
            <text-field v-model="fields.lastName1.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('firstName2') && !isArabicLanguage" class="w-full md:w-1/2">
          <form-group :attrs="fields.firstName2">
            <text-field v-model="fields.firstName2.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('lastName2') && !isArabicLanguage" class="w-full md:w-1/2">
          <form-group :attrs="fields.lastName2">
            <text-field v-model="fields.lastName2.value" />
          </form-group>
        </div>
        <div v-if="fieldIsPresent('email')" class="w-full md:w-1/2">
          <form-group :attrs="fields.email">
            <text-field v-model="fields.email.value" />
          </form-group>
        </div>
        <div v-if="isChinaDatacenter" class="w-full md:w-1/2 pt-2" style="margin-right: 50%">
          <span class="form-action__text text-sm" v-html="$t('Form.chinaUnsubscriptionText')" />
        </div>
      </div>
    </phoenix-form>
  </div>
</template>
